// removed by extract-text-webpack-plugin
module.exports = {"button":"src-components----page-module---button---ahqtu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page.module.css
// module id = 284
// module chunks = 201855264487804